import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Logo: React.FC = () => {
  const { resolvedTheme } = useTheme();

  return (
    <div className="flex items-center justify-center" aria-label="Engramiq Logo">
      <img
        src={resolvedTheme === 'dark' ? '/LOGO MARK AND TYPE - CMYK-02 (1).png' : '/logo-dark.png'}
        alt="Engramiq Logo"
        className="w-[300px] h-auto object-contain"
      />
    </div>
  );
};

export default Logo;
